import { Icon, type SemanticICONS } from "semantic-ui-react"

type ProfileLinkType = Record<
  string,
  {
    icon?: SemanticICONS
    iconLeftAlt?: string
    title: string
    link: string
  }
>

export const profileLinks: ProfileLinkType = {
  facebook: {
    icon: "facebook",
    title: "Facebook",
    link: "https://facebook.com/",
  },
  twitter: {
    iconLeftAlt: "X",
    title: "𝕏.com",
    link: "https://twitter.com/",
  },
  instagram: {
    icon: "instagram",
    title: "Instagram",
    link: "https://instagram.com/",
  },
  github: {
    icon: "github",
    title: "Github",
    link: "https://github.com/",
  },
  linkedin: {
    icon: "linkedin",
    title: "LinkedIn",
    link: "https://linkedin.com/in/",
  },
}

type SocialMediaLinkType = Record<
  string,
  {
    icon?: SemanticICONS
    iconLeftAlt?: string
    content: string
    link: string
    color: string
  }
>

export const socialMediaLinks: SocialMediaLinkType = {
  facebook: {
    icon: "facebook",
    content: "Facebook",
    link: "https://facebook.com/",
    color: "#1877F2",
  },
  twitter: {
    iconLeftAlt: "𝕏",
    content: "𝕏.com",
    link: "https://twitter.com/",
    color: "#1DA1F2",
  },
  instagram: {
    icon: "instagram",
    content: "Instagram",
    link: "https://instagram.com/",
    color: "#C13584",
  },
  github: {
    icon: "github",
    content: "Github",
    link: "https://github.com/",
    color: "#333",
  },
  linkedin: {
    icon: "linkedin",
    content: "LinkedIn",
    link: "https://linkedin.com/in/",
    color: "#0077B5",
  },
  website: {
    icon: "globe",
    content: "Website",
    link: "",
    color: "#000",
  },
}

type ProfileLinkProps = {
  type: keyof typeof profileLinks
  link: string
}

export const ProfileLink = ({ type, link }: ProfileLinkProps) => {
  const linkType = profileLinks[type]
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      {"icon" in linkType ? <Icon name={linkType.icon} /> : linkType.iconLeftAlt}{" "}
      <a className="with-border" href={`${linkType.link}${link}`} target="_blank" rel="noopener noreferrer">
        {linkType.title}
      </a>
    </div>
  )
}
